import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { BookingPayloadType } from "./types"

export interface ProceedBookingRequest extends Partial<AxiosRequestConfig> {
  params: BookingPayloadType
}

export interface ProceedBookingResponseData {
  bookingId: number
  bookingNo: string
  bookingTotalAmount: number
  errorCode?: string
  status: number
}

export interface ProceedBookingResponse extends AxiosResponse {
  data: ProceedBookingResponseData
}

export function confirmBookingApi(
  { params }: ProceedBookingRequest,
  axiosInstance: AxiosInstance,
): Promise<ProceedBookingResponse> {
  const url = `/booking/proceed`

  return axiosInstance({
    data: params,
    method: "post",
    url,
  }) as Promise<ProceedBookingResponse>
}
